import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const AboutSection: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        color: 'primary.main',
        padding: 6,
        position: 'relative',
        marginTop: '-5vh',
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="h4" align="center" sx={{ fontWeight: 'bold', mb: 3 }}>
          ABOUT US
        </Typography>
        <Typography variant="body1" align="center">
          Welcome to 5 Star Laundromat, where we bring you the ultimate in convenience, cleanliness, and modern technology. Our brand-new Dexter coinless, touchscreen machines allow for a fast, easy, and cashless experience. With intuitive touchscreens, selecting your wash cycle has never been simpler. Pay effortlessly via mobile app, saving you time and hassle.
          Need more time to focus on other things? Take advantage of our Wash & Fold service. Drop off your laundry, and we’ll take care of the rest—cleaned, folded, and ready to pick up at your convenience.
          While you wait, relax and enjoy our large-screen TVs for entertainment in a clean, comfortable space. At 5 Star Laundromat, we’re dedicated to making your laundry experience as efficient and stress-free as possible. Stop by today and see why we’re the five-star choice for all your laundry needs!
        </Typography>
      </Container>
    </Box>
  );
};

export default AboutSection;